import * as React from 'react'
import {ChangeEvent, Component, ReactElement} from 'react'
import {Box} from '@mui/material'
import {NatApplicationRepo} from '../../repository/NatApplicationRepo'
import {BlockSpacer, currentMedia, GridContainer, GridItem} from '../../../../../styledComponents/ResponsiveConvenience'
import {FlexContainer, FullWidthColumnFlexContainer} from '../../../../../styledComponents/FlexComponents'
import {convertToRoomNumberForResident, getCurrentYear} from '../../../../common/util/Natutil'
import NatCurrentDateTimeRepo from '../../../currentDateTime/repository/NatCurrentDateTimeRepo'
import moment from 'moment'
import {MONTH, PET_TYPE} from '../../../../../CodeMaster'
import {
    NatResidentLoginInfoSessionStorageHelper,
    ResidentLoginInfoSessionStorageKey,
} from '../../../../common/authentication/NatResidentLoginInfoSessionStorageHelper'
import {ApplyButton, ItemHeading, WideWhiteArea} from '../../common/resident/NatResidentApplicationsCommon'
import {NatGetCurrentDateTime} from '../../../currentDateTime/repository/NatGetCurrentDateTime'
import {NatResidentPetBreedingApplyLocationState} from '../NatResidentApplicationInterface'
import {Nullable} from '../../../../../app/TypeHelpers'
import EventEmitterExResident from '../../../../../components/shared/pageBaseComponents/EventEmitterExResident'
import NatCondominiumRepo from '../../../condominium/repository/NatCondominiumRepo'
import PPRadioGroupForResident from '../../../../../components/shared/forms/resident/PPRadioGroupForResident'
import NatResidentApplicationDetailFormItem from '../../common/resident/NatResidentApplicationDetailFormItem'
import HolidaysRepository from '../../../../../components/HolidaysRepository'
import {AsyncCallFunctionType} from '../../../../../components/shared/hoc/withAsyncCommunication'
import {PPTextFieldForResident} from '../../../../../components/shared/forms/resident/PPTextFieldForResident'
import styled from 'styled-components'
import {NatPutPetBreedingApplyRequest} from '../../repository/NatPutPetBreedingApply'
import PPImageInputWithPreviewForResident, {
    ImageInformation,
} from '../../../../../components/shared/forms/resident/PPImageInputWithPreviewForResident'
import PPSelectForResident, {Option} from '../../../../../components/shared/forms/resident/PPSelectForResident'
import {DisplayItemInputTitleRequiredNoMargin} from '../../../../../styledComponents/DisplayItem'
import ErrorMessageAreaWrapper from '../../../../../components/shared/forms/resident/ErrorMessageAreaWrapper'
import {StyledDiv} from '../../../../../styledComponents/StyledTypeDefinitions'
import {Location, NavigateFunction} from 'react-router-dom'


interface Props {
    condominiumCd: string
    applicationRepo: NatApplicationRepo
    currentDateTimeRepo: NatCurrentDateTimeRepo
    condominiumRepo: NatCondominiumRepo
    holidaysRepo: HolidaysRepository
    navigate: NavigateFunction
    location: Location<NatResidentPetBreedingApplyLocationState>
    eventEmitter: EventEmitterExResident
    asyncCallFunction: AsyncCallFunctionType

    applicantFamilyName: Nullable<string>
    applicantFirstName: Nullable<string>
    petType: Nullable<string>
    petBreed: Nullable<string>
    havePetStartMonth: Nullable<string>
    dogLicenseImage: Nullable<ImageInformation>
    rabiesImage: Nullable<ImageInformation>

    submitButtonLabel: string
    onClickApplyConfirmButton: (request: NatPutPetBreedingApplyRequest) => Promise<void>
}

interface State {
    applicantFamilyName: string
    applicantFirstName: string
    petType: string
    petBreed: string
    havePetStartYear: string
    havePetStartMonth: string
    dogLicenseImage: Nullable<ImageInformation>
    rabiesImage: Nullable<ImageInformation>

    currentDate: moment.Moment
    yearOptions: Option[]
    monthOptions: Option[]

    clearHavePetStartError: boolean
    applyButtonDisabled: boolean
    isLoadCompleted: boolean
}

export default class NatResidentPetBreedingApplyForm extends Component<Props, State> {

    constructor(props: Readonly<Props>) {
        super(props)

        this.state = {
            applyButtonDisabled: true,
            applicantFamilyName: '',
            applicantFirstName: '',
            petType: '',
            petBreed: '',
            havePetStartYear: '',
            havePetStartMonth: '',
            dogLicenseImage: null,
            rabiesImage: null,
            currentDate: moment(),
            yearOptions: [],
            monthOptions: [],
            clearHavePetStartError: false,
            isLoadCompleted: false,
        }
        this.handleChangeStartYear = this.handleChangeStartYear.bind(this)
        this.handleChangeStartMonth = this.handleChangeStartMonth.bind(this)
        this.handleChangePetType = this.handleChangePetType.bind(this)
        this.handleChangeText = this.handleChangeText.bind(this)
        this.onClickApplyConfirmButton = this.onClickApplyConfirmButton.bind(this)
        this.handleDogLicenseImagesChange = this.handleDogLicenseImagesChange.bind(this)
        this.handleRabiesImageChange = this.handleRabiesImageChange.bind(this)
    }

    async componentDidMount(): Promise<void> {
        await this.props.eventEmitter.showLoading()

        try {
            const [currentTimeResponse] = await Promise.all([
                this.getCurrentDateTime(),
            ])

            // 現在日時取得
            if (currentTimeResponse && currentTimeResponse.details) {
                const currentYear: number = getCurrentYear(`${currentTimeResponse.details.currentDateTime}`)
                const yearOptions: Option[] = [{label: '', value: ''}]
                const monthOptions: Option[] = [{label: '', value: ''}]

                let year: number = currentYear + 3
                for (let index: number = 1; index <= 7; index++) {
                    yearOptions.push({label: `${year}`, value: `${year}`})
                    year--
                }

                MONTH.values().map((month) => {
                    return (
                        monthOptions.push({
                            label: `${month.label}`, value: (String(month.value).length === 1)
                                ? '0' + String(month.value) : String(month.value),
                        })
                    )
                })
                this.setState({
                    currentDate: moment(currentTimeResponse.details.currentDateTime),
                    yearOptions: yearOptions,
                    monthOptions: monthOptions,
                })
            }

            const applicantFamilyName = this.props.applicantFamilyName ?? this.state.applicantFamilyName
            const applicantFirstName = this.props.applicantFirstName ?? this.state.applicantFirstName
            const petType = this.props.petType ?? this.state.petType
            const petBreed = this.props.petBreed ?? this.state.petBreed
            const havePetStart = this.props.havePetStartMonth ? this.props.havePetStartMonth.split('-') : []
            const dogLicenseImage = this.props.dogLicenseImage ?? this.state.dogLicenseImage
            const rabiesImage = this.props.rabiesImage ?? this.state.rabiesImage
            this.setState({
                applicantFamilyName: applicantFamilyName,
                applicantFirstName: applicantFirstName,
                petType: petType,
                petBreed: petBreed,
                havePetStartYear: havePetStart[0] ?? this.state.havePetStartYear,
                havePetStartMonth: havePetStart[1] ?? this.state.havePetStartMonth,
                dogLicenseImage: dogLicenseImage,
                rabiesImage: rabiesImage,
            }, () => {
                this.updateApplyConfirmButtonDisabled()
            })
        } finally {
            this.setState({isLoadCompleted: true})
            this.props.eventEmitter.closeLoading()
        }
    }

    async getCurrentDateTime(): Promise<Nullable<NatGetCurrentDateTime>> {
        const {currentDateTimeRepo, eventEmitter} = this.props

        return await this.props.asyncCallFunction(
            currentDateTimeRepo.getCurrentDateTime.bind(currentDateTimeRepo),
            async (httpErrorOrNetworkError) => {
                await httpErrorOrNetworkError.broadcast(eventEmitter)
            },
        )
    }

    handleChangeText(event: ChangeEvent<HTMLInputElement>): void {
        const key = event.target.name as keyof State
        const value: string = event.target.value
        this.setState({...this.state, [key]: value}, () => {
            this.updateApplyConfirmButtonDisabled()
        })
    }

    handleChangeStartYear(event: React.ChangeEvent<HTMLSelectElement>): void {
        this.setState({havePetStartYear: event.target.value, clearHavePetStartError: true}, () => {
            this.updateApplyConfirmButtonDisabled()
        })
    }

    handleChangeStartMonth(event: React.ChangeEvent<HTMLSelectElement>): void {
        this.setState({havePetStartMonth: event.target.value, clearHavePetStartError: true}, () => {
            this.updateApplyConfirmButtonDisabled()
        })
    }

    handleDogLicenseImagesChange(image: ImageInformation): void {
        this.setState({dogLicenseImage: image}, () => {
            this.updateApplyConfirmButtonDisabled()
        })
    }

    handleRabiesImageChange(image: ImageInformation): void {
        this.setState({rabiesImage: image}, () => {
            this.updateApplyConfirmButtonDisabled()
        })
    }

    handleChangePetType(event: ChangeEvent<HTMLInputElement>): void {
        this.setState({
            petType: event.target.value,
            dogLicenseImage: null,
            rabiesImage: null,
        }, () => {
            this.updateApplyConfirmButtonDisabled()
        })
    }

    updateApplyConfirmButtonDisabled(): void {
        const {
            applicantFamilyName, applicantFirstName, petType,
            petBreed, havePetStartYear, havePetStartMonth, dogLicenseImage, rabiesImage,
        } = this.state

        let applyButtonDisabled = false
        if (!applicantFamilyName || !applicantFirstName || !petType ||
            !petBreed || !havePetStartYear || !havePetStartMonth) {
            applyButtonDisabled = true
        }
        if (petType === PET_TYPE.DOG.value) {
            if (dogLicenseImage && rabiesImage) {
                if ((!dogLicenseImage.fileName || !dogLicenseImage.fileData) &&
                    (!dogLicenseImage.fileNumber || !dogLicenseImage.path)) {
                    applyButtonDisabled = true
                }
                if ((!rabiesImage.fileName || !rabiesImage.fileData) &&
                    (!rabiesImage.fileNumber || !rabiesImage.path)) {
                    applyButtonDisabled = true
                }
            } else {
                applyButtonDisabled = true
            }
        }
        this.setState({applyButtonDisabled: applyButtonDisabled})
    }

    async onClickApplyConfirmButton(): Promise<void> {
        const {
            applicantFamilyName, applicantFirstName, petType,
            petBreed, havePetStartMonth, havePetStartYear, dogLicenseImage, rabiesImage,
        } = this.state

        this.setState({clearHavePetStartError: false})

        let request: Nullable<NatPutPetBreedingApplyRequest>
        const date = havePetStartYear + '-' + havePetStartMonth

        request = {
            applicantFamilyName: applicantFamilyName,
            applicantFirstName: applicantFirstName,
            petType: petType,
            petBreed: petBreed,
            havePetStartMonth: date,
            healthCenterDogLicense: dogLicenseImage,
            rabiesPreventionInjectionCertification: rabiesImage,
            confirmed: false,
        }

        if (!request) {
            return
        }
        await this.props.onClickApplyConfirmButton(request)
    }

    renderApplicantForm(): ReactElement {
        const {applicantFamilyName, applicantFirstName} = this.state

        const applicantRoom = NatResidentLoginInfoSessionStorageHelper
                .getStringItemOrNull(ResidentLoginInfoSessionStorageKey.SELECTED_CONDOMINIUM_NAME) + '　' +
            NatResidentLoginInfoSessionStorageHelper
                .getStringItemOrNull(ResidentLoginInfoSessionStorageKey.SELECTED_RIDGENAME) + ' ' +
            convertToRoomNumberForResident(
                NatResidentLoginInfoSessionStorageHelper
                    .getStringItemOrNull(ResidentLoginInfoSessionStorageKey.SELECTED_ROOM_NUMBER),
            )

        return (
            <>
                <ItemHeading>
                    申請者
                </ItemHeading>
                <WideWhiteArea>
                    <Box height={'20px'}/>
                    {applicantRoom}
                    <Box height={'20px'}/>
                    <NatResidentApplicationDetailFormItem
                        title={'氏名'}
                        required
                        component={
                            <FlexContainer>
                                <PPTextFieldForResident
                                    inputProps={{
                                        name: 'applicantFamilyName',
                                        maxLength: 10,
                                        value: applicantFamilyName,
                                        onChange: this.handleChangeText,
                                        placeholder: '例：素敵',
                                    }}
                                    onChange={this.handleChangeText}
                                    eventKeys={['applicantFamilyName']}
                                    eventEmitter={this.props.eventEmitter}
                                />
                                <FlexContainer>
                                    <BlockSpacer width={5}/>
                                </FlexContainer>
                                <PPTextFieldForResident
                                    inputProps={{
                                        name: 'applicantFirstName',
                                        maxLength: 10,
                                        value: applicantFirstName,
                                        placeholder: '例：太郎',
                                    }}
                                    onChange={this.handleChangeText}
                                    eventKeys={['applicantFirstName']}
                                    eventEmitter={this.props.eventEmitter}
                                />
                            </FlexContainer>
                        }
                    />
                    <Box height={'20px'}/>
                </WideWhiteArea>
            </>
        )
    }

    renderPetTypeForm(): ReactElement {
        const {petType} = this.state

        return (
            <>
                <ItemHeading>
                    種類
                </ItemHeading>
                <WideWhiteArea>
                    <Box height={'20px'}/>
                    <DisplayItemInputTitleRequiredNoMargin>
                        飼育するペットの種類
                    </DisplayItemInputTitleRequiredNoMargin>
                    <Box height={'20px'}/>
                    <GridContainer>
                        <GridItem over={12}>
                            <PPRadioGroupForResident
                                data={PET_TYPE.values()}
                                selectValue={petType}
                                onChange={this.handleChangePetType}
                                eventKeys={['petType']}
                                eventEmitter={this.props.eventEmitter}
                            />
                        </GridItem>
                    </GridContainer>
                    <Box height={'20px'}/>
                </WideWhiteArea>
            </>
        )
    }

    renderHavePetStartMonthForm(): ReactElement {
        const {havePetStartMonth, havePetStartYear} = this.state
        return (
            <>
                <ItemHeading>
                    飼育開始月
                </ItemHeading>
                <WideWhiteArea>
                    <Box height={'20px'}/>
                    <NatResidentApplicationDetailFormItem
                        title={<span>飼育を<BreakPcOnly/>開始する予定月</span>}
                        required
                        component={
                            <ErrorMessageAreaWrapper>
                                <DisplayFlex>
                                    <UnitBoxArea>
                                        <PPSelectForResident
                                            inputProps={{
                                                value: havePetStartYear,
                                            }}
                                            placeholder={'年'}
                                            onChange={this.handleChangeStartYear}
                                            options={this.state.yearOptions}
                                            eventKeys={[`havePetStartMonth`]}
                                            eventEmitter={this.props.eventEmitter}
                                            clearError={this.state.clearHavePetStartError}
                                        />
                                    </UnitBoxArea>
                                    <FlexContainer>
                                        <BlockSpacer width={5}/>
                                    </FlexContainer>
                                    <UnitBoxArea>
                                        <PPSelectForResident
                                            inputProps={{
                                                value: havePetStartMonth,
                                            }}
                                            placeholder={'月'}
                                            onChange={this.handleChangeStartMonth}
                                            options={this.state.monthOptions}
                                            eventKeys={[`havePetStartMonth`]}
                                            eventEmitter={this.props.eventEmitter}
                                            messageInvisible
                                            clearError={this.state.clearHavePetStartError}
                                        />
                                    </UnitBoxArea>
                                    <FlexContainer>
                                        <BlockSpacer width={8}/>
                                    </FlexContainer>
                                    <StringFlexDiv>から</StringFlexDiv>
                                </DisplayFlex>
                            </ErrorMessageAreaWrapper>
                        }
                    />
                    <Box height={'20px'}/>
                </WideWhiteArea>
            </>
        )
    }

    renderPetBreedForm(): ReactElement {
        const {petBreed} = this.state

        return (
            <>
                <ItemHeading>
                    品種
                </ItemHeading>
                <WideWhiteArea>
                    <Box height={'20px'}/>
                    <NatResidentApplicationDetailFormItem
                        title={'飼育するペットの品種'}
                        required
                        component={
                            <FlexContainer>
                                <PPTextFieldForResident
                                    inputProps={{
                                        maxLength: 50,
                                        name: 'petBreed',
                                        value: petBreed,
                                        placeholder: '例：チワワ',
                                    }}
                                    onChange={this.handleChangeText}
                                    eventKeys={['petBreed']}
                                    eventEmitter={this.props.eventEmitter}
                                />
                            </FlexContainer>
                        }
                    />
                    <Box height={'20px'}/>
                </WideWhiteArea>
            </>
        )
    }

    renderImageInputForm(): ReactElement {
        if (this.state.petType !== PET_TYPE.DOG.value) {
            return (<></>)
        }
        return (
            <>
                <ItemHeading>
                    保健所犬鑑札
                </ItemHeading>
                <WideWhiteArea>
                    <Box height={'20px'}/>
                    <NatResidentApplicationDetailFormItem
                        title={'お住まいの市区町村へ飼い犬を登録した際に交付された「犬鑑札」を提出'}
                        required
                        component={
                            <PPImageInputWithPreviewForResident
                                maxInput={1}
                                images={this.state.dogLicenseImage ? [this.state.dogLicenseImage] : null}
                                eventKey={'healthCenterDogLicense'}
                                onChange={this.handleDogLicenseImagesChange}
                                eventEmitter={this.props.eventEmitter}
                            />
                        }
                    />
                    <Box height={'20px'}/>
                </WideWhiteArea>
                <Box height={'15px'}/>
                <ItemHeading>
                    狂犬病予防注射済証
                </ItemHeading>
                <WideWhiteArea>
                    <Box height={'20px'}/>
                    <NatResidentApplicationDetailFormItem
                        title={'狂犬病予防注射の接種を受けた際に交付された「狂犬病予防注射済証」を提出'}
                        required
                        component={
                            <PPImageInputWithPreviewForResident
                                maxInput={1}
                                images={this.state.rabiesImage ? [this.state.rabiesImage] : null}
                                eventKey={'rabiesPreventionInjectionCertification'}
                                onChange={this.handleRabiesImageChange}
                                eventEmitter={this.props.eventEmitter}
                            />
                        }
                    />
                    <Box height={'20px'}/>
                </WideWhiteArea>
            </>)
    }

    render(): ReactElement {
        const {submitButtonLabel} = this.props
        const {applyButtonDisabled} = this.state

        if (!this.state.isLoadCompleted) {
            return (<></>)
        }

        return (
            <>
                {this.renderApplicantForm()}
                < Box height={'15px'}/>
                {this.renderPetTypeForm()}
                <Box height={'15px'}/>
                {this.renderPetBreedForm()}
                < Box height={'15px'}/>
                {this.renderHavePetStartMonthForm()}
                <Box height={'15px'}/>
                {this.renderImageInputForm()}
                <ApplyButton disabled={applyButtonDisabled} onClick={this.onClickApplyConfirmButton}>
                    <FullWidthColumnFlexContainer>
                        <div>
                            {submitButtonLabel}
                        </div>
                    </FullWidthColumnFlexContainer>
                </ApplyButton>
            </>
        )
    }
}

const BreakPcOnly = styled('br')`
  ${currentMedia.lessThan('sp')`
    display: none;
  `};
`

const UnitBoxArea: StyledDiv = styled.div`
  width: 150px;
  ${currentMedia.greaterThan('pc')`
    width: 165px;
  `};
`

const DisplayFlex: StyledDiv = styled.div`
  display: flex;
`

const StringFlexDiv: StyledDiv = styled.div`
  display: flex;
  max-height: 50px;
  align-items: flex-end;
`
